export const styles = {
  dialog: {
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      height: '48px',
      padding: 0,
      '& button': {
        margin: '0 12px',
      },
    },

    '& .MuiDialog-paper': {
      width: '650px',
      maxWidth: '650px',
      padding: '40px 0 0 0',
      borderRadius: '12px',
      overflow: 'auto',
      backgroundColor: '#fff',
    },
  },
  content: {
    padding: '20px 40px 0 40px',
    '& .btn': {
      width: '70px !important',
      minWidth: '70px !important',
    },
    '& .btn.filled-btn': {
      width: '123px !important',
      minWidth: '123px !important',
    },
  },
};
